import React, { PropTypes } from 'react'
import InputField from 'components/InputField/InputField';
import PasswordField from 'components/InputField/PasswordField.jsx';

const labels = {
  old_password: 'Old password',
  password: 'New password',
  password_confirmation: 'Repeat new password'
}

const ChangePasswordForm = ({
  user: {
    password,
    password_confirmation,
    old_password
  },
  errors,
  onFieldChange,
  onSubmit,
  onPasswordChangeVisibility,
  passwordVisibility
}) => (
  <div className="container_form">
    <div className="section_form row">
      <form className="col s12" onSubmit={onSubmit}>
        <div className="row">
          <PasswordField
            className='col s12'
            label={labels['old_password']}
            onChange={onFieldChange}
            errors={errors['old_password']}
            autoComplete='new-password'
            field_name={'old_password'}
            value={old_password}
            type={'password'}
            onPasswordChangeVisibility={(value) => onPasswordChangeVisibility('old_password', value)}
            showPassword={passwordVisibility.old_password}
          />
          <PasswordField
            className='col s12'
            label={labels['password']}
            onChange={onFieldChange}
            errors={errors['password']}
            autoComplete='new-password'
            field_name={'password'}
            value={password}
            type='password'
            onPasswordChangeVisibility={(value) => onPasswordChangeVisibility('password', value)}
            showPassword={passwordVisibility.password}
          />
          <PasswordField
            className='col s12'
            label={labels['password_confirmation']}
            onChange={onFieldChange}
            errors={errors['password_confirmation']}
            autoComplete='new-password'
            field_name={'password_confirmation'}
            value={password_confirmation}
            type='password'
            onPasswordChangeVisibility={(value) => onPasswordChangeVisibility('password_confirmation', value)}
            showPassword={passwordVisibility.password_confirmation}
          />
        </div>
        <div className="submit_center col s12">
          <input className="container_password_button" type="submit" name="" value="Update password" />
        </div>
      </form>
    </div>
  </div>
)

ChangePasswordForm.propTypes = {
  user: PropTypes.object,
  errors: PropTypes.object,
  onFieldChange: PropTypes.func,
  onSubmit: PropTypes.func,
}

export default ChangePasswordForm;



/** WEBPACK FOOTER **
 ** ./src/components/Authorization/ChangePassword/ChangePassword.jsx
 **/